/** Returns `obj` with `key` set, or removed when `value` is undefined (exactOptionalPropertyTypes). */
export function withOptional<T extends object, K extends keyof T>(
  obj: T,
  key: K,
  value: T[K] | undefined,
): T {
  if (value !== undefined) return { ...obj, [key]: value };
  return Object.fromEntries(Object.entries(obj).filter(([k]) => k !== key)) as T;
}
